export default function initExpand() {
    const $expandContainers = document.querySelectorAll<HTMLElement>('.js-expand');
    $expandContainers.forEach($container => {
        new Expand($container);
    });
}

class Expand {
    $el: HTMLElement;
    $details: NodeListOf<HTMLDetailsElement>;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$details = this.$el.querySelectorAll('details');

        this.init();
    }

    init() {
        this.$details.forEach($detail => {
            $detail.addEventListener('toggle', () => {
                if ($detail.open) {
                    // Fermer tous les autres details du même container
                    this.$details.forEach($otherDetail => {
                        if ($otherDetail !== $detail && $otherDetail.open) {
                            $otherDetail.open = false;
                        }
                    });
                }
            });
        });
    }
}
